const clientReports = {
  fileName: "File Name",
  size: "Size",
  uploadedBy: "Uploaded By",
  uploadDate: "Upload Date Time",
  actions: "Actions",
  uploadReport: "Upload Report",
  downloadAll: "Download All",
  searchPlaceholder: "Search by Report Name",
  showingRange: "Showing {from}-{to} of {total} reports",
  emptyTitle: "No reports yet",
  emptyDescription: "Upload the first report to share it with this event's client.",
  noResultsTitle: "No reports found",
  noResultsDescription: "No reports match your search.",
  downloadError: "Sorry, the file could not be downloaded.",
  downloadRetryError: "Unable to download the file. Please try again.",
  unknownUploader: "Not recorded",
  fileTypes: {
    pdf: "PDF document",
    png: "PNG image",
    jpg: "JPG image",
    xlsx: "Excel spreadsheet",
    html: "HTML document",
  },
  uploadModal: {
    title: "Upload Report",
    description: "Share a report with this event's client.",
    submit: "Upload",
    uploadClickToUpload: "Click to upload",
    uploadDragHint: "or drag and drop",
    uploadHint: "PNG, JPG, PDF, Excel or HTML (Max 10MB)",
    uploadTypeError: "Accepted formats are PNG, JPG, PDF, Excel and HTML only",
    uploadMaxSizeError: "Max size is 10MB",
    readyToUpload: "Ready to upload",
    removeFile: "Remove file",
  },
  downloadModal: {
    title: "Download Report",
    readyToDownload: "Ready to Download",
  },
  delete: "Delete",
  deleteModal: {
    title: "Delete Report",
    uploadedOn: "Uploaded on {date}",
    warning:
      "The file will be removed for both the company and the client and cannot be recovered.",
    confirmQuestion: "Are you sure you want to delete this report?",
    confirm: "Delete",
    success: "Report deleted successfully",
    error: "Unable to delete the report. Please try again.",
  },
  previewModal: {
    unsupportedType:
      "Preview is not available for this file type. Download the file to view it.",
    loadError: "Unable to load preview",
    pageOf: "Page {page} of {pages}",
    previousPage: "Previous page",
    nextPage: "Next page",
    sheetTruncated:
      "Showing the first {rows} rows. Download the file for the full sheet.",
  },
  downloadAllModal: {
    title: "Download All Report",
    submit: "Download All",
    selectedCount: "{count} Reports files are selected",
    loading: "Preparing reports...",
  },
};

export default clientReports;
